(function ($) {
  "use strict";

  // Quiz Offer Module
  const QuizOfferUI = {
    init() {
      this.bindScrollToOffer();
      this.initializeModules();
      this.initializeStickyHeader();
      this.scrollToQuizOffer();
    },

    initializeStickyHeader() {
      const $header = $(".quiz_offer_header");
      let lastScrollTop = 0;
      let isScrollingUp = false;
      let ticking = false;
      let headerHeight = $header.outerHeight();

      // Update header height on resize
      $(window).on("resize", () => {
        headerHeight = $header.outerHeight();
      });

      $(window).on("scroll", () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentScrollTop = $(window).scrollTop();
            isScrollingUp = currentScrollTop < lastScrollTop;
            lastScrollTop = currentScrollTop;

            // If we're at the top of the page
            if (currentScrollTop <= 0) {
              $header.removeClass(
                "quiz_offer_header-sticky quiz_offer_header-scrolled-passed"
              );
            }
            // If we're scrolling up and past the header height
            else if (isScrollingUp && currentScrollTop > headerHeight) {
              $header
                .addClass("quiz_offer_header-sticky")
                .removeClass("quiz_offer_header-scrolled-passed");
            }
            // If we're scrolling down and past the header height
            else if (!isScrollingUp && currentScrollTop > headerHeight) {
              $header
                .addClass("quiz_offer_header-scrolled-passed")
                .removeClass("quiz_offer_header-sticky");
            }

            ticking = false;
          });
          ticking = true;
        }
      });
    },

    bindScrollToOffer() {
      $(".qz_start_btn.button").on("click", (evt) => {
        evt.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $(".qmo_outer").offset().top,
          },
          300
        );
      });
    },

    initializeModules() {
      // Check if required modules are loaded
      if (this.areModulesReady()) {
        this.setupModules();
      } else {
        // Retry after 100ms if modules aren't loaded
        setTimeout(() => this.initializeModules(), 100);
      }
    },

    areModulesReady() {
      return (
        typeof QuizOffer !== "undefined" &&
        QuizOffer.init &&
        typeof QuizStorage !== "undefined"
      );
    },

    setupModules() {
      // Initialize UI components
      this.initializeTabs();
      this.initializeBarkynCareModal();
      this.initializeWhatsInsideModals();
      this.initializeAnalysisRows();

      // Initialize the main QuizOffer module first
      if (typeof QuizOffer !== "undefined" && QuizOffer.init) {
        QuizOffer.init();

        // Wait a moment for QuizOffer to initialize product variants
        setTimeout(() => {
          // Update offer-specific dynamic content after QuizOffer is initialized
          this.updateOfferContent();
        }, 150);
      } else {
        // If QuizOffer is not available, still update content with available data
        this.updateOfferContent();
      }
    },

    initializeAnalysisRows() {
      // Set percentage-based backgrounds for analysis rows
      $(".qz_analysis_row").each(function () {
        const percentage = $(this).data("percentage");
        if (percentage) {
          $(this).css("--percentage", percentage + "%");
        }
      });
    },

    initializeTabs() {
      const $tabTriggers = $(".tab-trigger");
      const $tabContents = $(".qz_mo_tab_content");

      $tabTriggers.on("click", function () {
        const $this = $(this);
        const tabId = $this.data("tab");

        // Update active state
        $tabTriggers.removeClass("active");
        $this.addClass("active");

        // Show corresponding content
        $tabContents.hide();
        $tabContents.filter(`[data-tab="${tabId}"]`).show();

        QuizOfferUI.updateOfferContent();
      });
    },

    initializeBarkynCareModal() {
      // Get modal elements
      const $modal = $("#barkyn-care-modal");

      // If modal doesn't exist, return early
      if (!$modal.length) return;

      const $closeBtn = $modal.find(".barkyn-modal-close");

      // Get all learn more buttons
      const $learnMoreBtns = $(".qz_mo_learn_more_btn");

      // Open modal when learn more button is clicked
      $learnMoreBtns.on("click", function (e) {
        e.preventDefault();
        $modal.css("display", "flex");
        $("html").css("overflow", "hidden"); // Prevent scrolling
      });

      // Close modal when close button is clicked
      $closeBtn.on("click", function () {
        $modal.css("display", "none");
        $("html").css("overflow", ""); // Restore scrolling
      });

      // Close modal when clicking outside the content
      $modal.on("click", function (e) {
        if (e.target === this) {
          $modal.css("display", "none");
          $("html").css("overflow", ""); // Restore scrolling
        }
      });

      // Close modal when ESC key is pressed
      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && $modal.css("display") === "flex") {
          $modal.css("display", "none");
          $("html").css("overflow", ""); // Restore scrolling
        }
      });
    },

    initializeWhatsInsideModals() {
      // Get modal elements
      const $modalTriggers = $("[data-modal-trigger]");
      const $modals = $(".qz_modal.whats_inside_modal");

      // If no modals or triggers exist, return early
      if (!$modals.length || !$modalTriggers.length) return;

      const $closeButtons = $modals.find(".qz_modal_close");

      // Open modal when trigger is clicked
      $modalTriggers.on("click", function () {
        const modalId = $(this).data("modal-trigger");
        const $modal = $("#" + modalId);

        if ($modal.length) {
          $modal.css("display", "flex");
          $("html").css("overflow", "hidden"); // Prevent scrolling
        }
      });

      // Close modal when close button is clicked
      $closeButtons.on("click", function () {
        const $modal = $(this).closest(".qz_modal");
        $modal.css("display", "none");
        $("html").css("overflow", ""); // Restore scrolling
      });

      // Close modal when clicking outside the content
      $modals.on("click", function (e) {
        if (e.target === this) {
          $(this).css("display", "none");
          $("html").css("overflow", ""); // Restore scrolling
        }
      });

      // Close modal when ESC key is pressed
      $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
          const $visibleModal = $(".qz_modal.whats_inside_modal:visible");
          if ($visibleModal.length) {
            $visibleModal.css("display", "none");
            $("html").css("overflow", ""); // Restore scrolling
          }
        }
      });
    },

    getQuizData() {
      return QuizStorage.getQuizAnswers() || {};
    },

    updateOfferContent() {
      const answers = this.getQuizData();

      // Update offer-specific elements
      this.updateProteinText(answers);
      this.updateReviews(answers);
    },

    updateProteinText(data) {
      if (!data) return;

      // Get the selected tab/plan type
      const selectedPlan =
        $(".qz_mo_plan_title.active").data("tab") || "monthly";
      // Get the selected variant from QuizOffer
      let selectedVariant = null;
      if (typeof QuizOffer !== "undefined" && QuizOffer.selectedVariants) {
        selectedVariant = QuizOffer.selectedVariants[selectedPlan];
      }

      // --- 1. LANGUAGE CONFIGURATION & TRANSLATIONS ---
      const currentLang = window.Shopify?.locale || "pt";

      const t = window.quizJSTranslations || {
        // Fallback to PT
        flavor_hypo: "Proteína: Pato & coelho",
        title_trial_hypo: "Ração hipoalergénica para 7 dias",
        title_monthly_hypo: "Ração hipoalergénica",
        prefix_light: "Proteína light: ",
        prefix_mini: "Proteína mini: ",
        prefix_std: "Proteína: ",
        chicken_turkey: "Frango & peru",
      };

      let proteinText = "";

      if (selectedVariant) {
        // Toggle what's inside blocks based on grain-free status
        $(".qz_offer_whats_inside_block.food").hide();
        if (selectedVariant.isGrainFree) {
          $(".qz_offer_whats_inside_block.food.grain-free").show();
        } else {
          $(".qz_offer_whats_inside_block.food.low-grain").show();
        }

        const variantProtein = selectedVariant.protein || selectedVariant.title;
        const variantTitleLower = (selectedVariant.title || "").toLowerCase();
        const variantProteinLower = (variantProtein || "").toLowerCase();

        // --- 2. HYPOALLERGENIC LOGIC ---
        const isHypo =
          variantTitleLower.includes("hipo") ||
          variantTitleLower.includes("hypo") ||
          variantProteinLower.includes("ipo");

        if (isHypo) {
          $(".js-summary-flavor").text(t.flavor_hypo);
          if (selectedPlan === "trial") {
            $(".js-summary-title").text(t.title_trial_hypo);
          } else {
            $(".js-summary-title").text(t.title_monthly_hypo);
          }
          return; // Exit function, no need to calculate standard protein text
        }

        // --- 3. OPTIMIZED STANDARD LOGIC (Light / Mini / Standard) ---

        // Helper: Removes "fresco", "freschi", "frescos" (case insensitive)
        const cleanProtein = (str) => str.replace(/ fresc[ohi]s?/gi, "").trim();

        // Helper: Detects mini kibble (PT: biscoito mini, ES: pequeñas, IT: piccole)
        const isMini = variantProteinLower.match(/mini|pequeñas|piccole/);

        if (variantProteinLower.includes("light")) {
          // Remove "light" and "fresh"
          const baseProtein = variantProtein.replace(/ light/gi, "");
          proteinText = `${t.prefix_light}${cleanProtein(baseProtein)}`;
        } else if (isMini) {
          // Remove everything after " · " (usually biscuit size)
          const baseProtein = variantProtein.split(" · ")[0];
          proteinText = `${t.prefix_mini}${cleanProtein(baseProtein)}`;
        } else if (
          variantProteinLower.includes("& peru") ||
          variantProteinLower.includes("y pavo") ||
          variantProteinLower.includes("e tacchino")
        ) {
          // Normalize Chicken & Turkey for the correct language
          proteinText = `${t.prefix_std}${t.chicken_turkey}`;
        } else {
          // Standard format
          proteinText = `${t.prefix_std}${cleanProtein(variantProtein)}`;
        }
      } else {
        // Fallback if no variant is available
        proteinText = `${t.prefix_std}${t.chicken_turkey}`;

        $(".qz_offer_whats_inside_block.food").hide();
        $(".qz_offer_whats_inside_block.food.low-grain").show();
      }

      // Update the vitamins element with the protein text
      $(".qz_mo_vitamins").html(proteinText);
      $(".protein-chicken").html(proteinText);
    },

    updateReviews(data) {
      if (!data) return;

      // Get concerns from data
      const concerns = data.concerns || (data.dog && data.dog.concerns);

      // Hide all reviews first
      $(".qz_review_item").hide();

      if (!concerns || concerns === "noConcerns" || concerns === "none") {
        // Show default review if no concerns
        $(".qz_review_item.default-review").show();
      } else {
        // Get primary concern (first one if multiple)
        const primaryConcern = concerns.split(";")[0].trim().toLowerCase();
        let matchFound = false;

        // Find matching review
        $(".qz_review_item").each(function () {
          const reviewConcern = $(this).attr("data-concern");
          if (reviewConcern && reviewConcern.toLowerCase() === primaryConcern) {
            $(this).show();
            matchFound = true;
            return false; // Break the loop
          }
        });

        // Show default review if no match found
        if (!matchFound) {
          $(".qz_review_item.default-review").show();
        }
      }
    },

    scrollToQuizOffer() {
      // Wait for the page to be fully loaded
      $(window).on("load", () => {
        // Only scroll if user is at the top of the page
        if ($(window).scrollTop() === 0) {
          const $quizOffer = $("#quiz_main_offer");
          if ($quizOffer.length) {
            $("html, body").animate(
              {
                scrollTop: $quizOffer.offset().top,
              },
              800
            );
          }
        }
      });
    },
  };

  // Initialize when DOM is ready
  $(document).ready(() => {
    QuizOfferUI.init();
  });
})(jQuery);
